
import ClickOutside from "vue-click-outside";
import { mapGetters, mapState } from "vuex";

export default {
  directives: { ClickOutside },

  data: () => ({ selectedOptionName: "" }),

  computed: {
    ...mapGetters("bedbuilder", [
      "showOptionsModalOpen",
      "selectedOptionValues",
    ]),

    ...mapState("bedbuilder", [
      "activeOption",
      "baseOptions",
      "showBedBuilderOptionsChange",
    ]),

    selectedOption() {
      return this.selectedOptionValues;
    },
  },

  methods: {
    handleSelection(option) {
      this.selectedOptionName = option;
    },
  },
};
